/**
 * Utility functions for managing browser fullscreen mode
 */

/**
 * Attempts to enter fullscreen mode for the entire document
 * @returns {Promise<void>}
 */
export const enterFullScreen = () => {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    return element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    /* Firefox */
    return element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    /* Chrome, Safari and Opera */
    return element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    /* IE/Edge */
    return element.msRequestFullscreen();
  }
  return Promise.reject(new Error("Fullscreen API not supported"));
};

/**
 * Attempts to exit fullscreen mode
 * @returns {Promise<void>}
 */
export const exitFullScreen = () => {
  if (document.exitFullscreen) {
    return document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    /* Firefox */
    return document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    /* Chrome, Safari and Opera */
    return document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    /* IE/Edge */
    return document.msExitFullscreen();
  }
  return Promise.reject(new Error("Fullscreen API not supported"));
};

/**
 * Checks if the document is currently in fullscreen mode
 * @returns {boolean}
 */
export const isCurrentlyFullscreen = () => {
  return !!(
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  );
};
